import React, { useEffect, useState } from "react";
import APopover from "../../../../common/a-popover";
import AButton from "../../../../common/form-fields-mui/AButton";
import AAutoComplete from "../../../../common/form-fields-mui/AAutoComplete";
import AInput from "views/pages/manage/common/formFeilds/customInput/AInput";
import { Card, CardBody } from "reactstrap";
import { highlightedStyle } from "views/pages/manage/edpOps/stockManagement/mastersAndMapping/onBoardingMaterialIdSetup/SearchFilter";
import { getFilterCount } from "../../mastersAndMapping/onBoardingMaterialIdSetup/constant";
import { dropdownMapping } from "views/pages/manage/unAssigned/studentCharges/common";
import { endpoint } from "views/pages/manage/common/constant";

const changeValueToLabel = (items = []) => {
  if (!Array.isArray(items)) return [];
  const results = [...items];
  return results.map((item) => ({ ...item, value: item.label?.toUpperCase() }));
};

const dropdown = {
  type: [
    { label: "Serialized", value: "serialised" },
    { label: "Non Serialized", value: "non-serialised" },
  ],
  status: [
    { label: "Active", value: "ACTIVE" },
    { label: "Inactive", value: "INACTIVE" },
  ],
  plantId: [
    { label: "HO01", value: "HO01" },
    { label: "DP01", value: "DP01" },
    { label: "DG01", value: "DG01" },
  ],
};

const SearchFilterForm = ({
  closeForm,
  filterCount,
  filterPayload,
  removeFilterHandler,
  dynamicDropdown,
  applyFilter = () => {},
}) => {
  const initialFilterForm = {
    materialId: "",
    status: "",
    plantId: "",
    type: "",
    studentClass: "",
    carrier: "",
    attributeDisplayValue: "",
    pkgCode: "",
  };

  const [filterForm, setFilterForm] = useState(
    filterPayload || initialFilterForm
  );
  // const [dynamicDropdown, setDynamicDropdown] = useState([]);

  useEffect(() => {
    setFilterForm(filterPayload || {});
    // Fetch carrier and student class options
  }, []);

  const handleFilterChange = (value, key) => {
    setFilterForm((prev) => ({ ...prev, [key]: value }));
  };

  const onRemoveHandler = () => {
    removeFilterHandler();
    setFilterForm({});
    closeForm();
  };

  return (
    <Card
      className="mb-0 regular-body label-color"
      style={{ width: "330px", borderRadius: "12px" }}
    >
      <CardBody className="d-flex flex-column">
        <div className="mb-1 d-flex align-items-start justify-content-between">
          <div className="regular-large-bold">Filter by</div>
        </div>
        <div className="d-flex flex-column gap-md">
          {Object.keys(dropdown).map((key) => (
            <AAutoComplete
              key={key}
              label={key.charAt(0).toUpperCase() + key.slice(1)}
              currentValue={filterForm[key] || []}
              items={dropdown[key]}
              handleChange={(value) => handleFilterChange(value, key)}
              isMulti={false}
            />
          ))}
          <AAutoComplete
            label="Language"
            currentValue={filterForm.language || ""}
            items={changeValueToLabel(dynamicDropdown.languageMaster || [])}
            handleChange={(value) => handleFilterChange(value, "language")}
            isMulti={false}
          />
          <AAutoComplete
            label="Class"
            currentValue={filterForm.studentClass || ""}
            items={changeValueToLabel(dynamicDropdown.studentClass || [])}
            handleChange={(value) => handleFilterChange(value, "studentClass")}
            isMulti={false}
          />
          <AAutoComplete
            label="Career"
            currentValue={filterForm.carrier || ""}
            items={changeValueToLabel(dynamicDropdown.carrier || [])}
            handleChange={(value) => handleFilterChange(value, "carrier")}
            isMulti={false}
          />
          <AAutoComplete
            label="Attribute"
            currentValue={filterForm.attributeDisplayValue || ""}
            items={changeValueToLabel(dynamicDropdown.courseAttribute || [])}
            handleChange={(value) =>
              handleFilterChange(value, "attributeDisplayValue")
            }
            isMulti={false}
          />

          <AInput
            label="Pkg Code"
            value={filterForm.pkgCode || ""}
            placeholder="Enter pkg code"
            handler={(value) => handleFilterChange(value, "pkgCode")}
          />
        </div>
        <div className="mt-3 d-flex flex-row-reverse justify-content-between">
          <AButton
            variant="primary_filled"
            className="button_remove_left_margin"
            onClick={() => {
              closeForm();
              applyFilter(filterForm);
            }}
            disabled={!getFilterCount(filterForm)}
          >
            Apply filter
          </AButton>
          {filterCount > 0 && (
            <AButton
              variant="outline"
              className="button_remove_left_margin"
              updatedStyle={{ border: "1px solid #CC5F5F", color: "#CC5F5F" }}
              onClick={onRemoveHandler}
            >
              Remove filter
            </AButton>
          )}
        </div>
      </CardBody>
    </Card>
  );
};

const Filter = ({
  dropdown,
  dynamicDropdown,
  filterForm,
  applyFilter,
  removeFilterHandler,
}) => {
  const filterCount = getFilterCount(filterForm);

  return (
    <div className="d-flex justify-content-end align-items-center">
      <APopover
        buttonComponent={(onClick, styles) => (
          <AButton
            className="color-dark"
            onClick={onClick}
            updatedStyle={{
              minWidth: "61px",
              ...(filterCount > 0 ? highlightedStyle : styles),
            }}
          >
            Filter {filterCount > 0 && <>( {filterCount} )</>}
          </AButton>
        )}
        menuComponent={(closeForm) => (
          <SearchFilterForm
            closeForm={closeForm}
            filterCount={filterCount}
            applyFilter={applyFilter}
            filterPayload={filterForm}
            removeFilterHandler={removeFilterHandler}
            dynamicDropdown={dynamicDropdown}
          />
        )}
        maxHeight="calc(100vh - 250px)"
      />
    </div>
  );
};

export default Filter;
